import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { defaultResources } from "./translations.js";
import { urlToAbsolute } from './urlToAbsolute';
import { logWithOffset, errorWithOffset } from "./logWithOffset";
let ready = null;

export async function setupTranslations(translationsUrl) {
  let resources = null;


  try {
    if (translationsUrl !== "") {
      const res = await fetch(urlToAbsolute(translationsUrl));
      resources = await res.json();
      logWithOffset(`Loaded translations file: ${urlToAbsolute(translationsUrl)}`);
    } else {
      logWithOffset(`Using default translation file`);
    }
  } catch(e) {
    errorWithOffset(`Failed to load translations file: ${urlToAbsolute(translationsUrl)} (${e})`);
  }

  resources = resources || defaultResources;

  i18next.use(LanguageDetector).init({
    fallbackLng: "en",
    resources
  });
  ready = true;
}
